import { render, staticRenderFns } from "./proc_query.vue?vue&type=template&id=33b3d54e&scoped=true&"
import script from "./proc_query.vue?vue&type=script&lang=js&"
export * from "./proc_query.vue?vue&type=script&lang=js&"
import style0 from "./proc_query.vue?vue&type=style&index=0&id=33b3d54e&scoped=true&lang=less&"
import style1 from "./proc_query.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b3d54e",
  null
  
)

export default component.exports